import { MutableComponent } from "@baseline/ui/apps";
import { StyleModules, useService } from "@baseline/ui/react";
import React, { FC, useMemo } from "react";

import { ConfigurationService } from "../../config";
import { AppScreen } from "./app-screen";

export const Page: FC = () => {
  const configurationService = useService(ConfigurationService);

  const adyenCss = useMemo(() => {
    const environment = configurationService.get("environment");
    const adyenEnvironment = environment !== "production" ? "test" : "live";
    return `https://checkoutshopper-${adyenEnvironment}.adyen.com/checkoutshopper/sdk/6.6.0/adyen.css`;
  }, [configurationService]);

  return (
    <html>
      <head>
        <meta charSet="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />

        <title>White Labelled Web Drop-In</title>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link
          rel="preconnect"
          href="https://fonts.gstatic.com"
          crossOrigin="anonymous"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Noto+Sans:ital,wght@0,100..900;1,100..900&display=swap"
          rel="stylesheet"
        />

        <link id="adyen-css" href={adyenCss} rel="stylesheet" />

        <style>
          {`body {
            font-family: "Noto Sans", sans-serif;
            font-optical-sizing: auto;
            font-weight: 400;
            font-style: normal;
            font-variation-settings: "wdth" 100;
          }`}
        </style>

        <StyleModules />
      </head>
      <body>
        <MutableComponent component={AppScreen} />
      </body>
    </html>
  );
};
